export default __webpack_public_path__ + "static/gearsPop-white-fd6e50cdfa4652580aa092d820eee9a6.svg";